import Home from '@/pages/Home.svelte';
// import Form from '@/pages/Form.svelte';
import FormData from '@/pages/FormData.svelte';
// import FormData2 from '@/pages/FormData2.svelte';
import SimpleFormData from '@/pages/SimpleFormData.svelte';
import View from '@/pages/View.svelte';
import SimpleView from '@/pages/SimpleView.svelte';
import Load from '@/pages/Load.svelte';
import List from '@/pages/List.svelte';
import Page from '@/pages/Page.svelte';
import Test from '@/pages/Test.svelte';
import NotFound from '@/pages/NotFound.svelte';

export default {
    '/': Home,
    // '/home': Home,
    '/load': Load,
    '/list': List,
    '/page': Page,
    '/test': Test,
    '/view': View,
    // '/form': Form,
    '/formdata': FormData,
    // '/formdata2': FormData2,
    '/simpleformdata': SimpleFormData,
    '/simpleview': SimpleView,
    // '/form/*': Form,
    // The catch-all route must always be last
    '*': NotFound
};